import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast } from "#app/notifications";
import { deleteRecentSearch } from "#modules/search/infra/deleteRecentSearch.api";
import { recentSearchesQuery } from "#modules/search/infra/recentSearches.query";

export const useDeleteRecentSearch = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: deleteRecentSearch,

    onError: (error: Error) => {
      showErrorToast({ title: t("searchPage.removeRecentError") });
      errorHandler(error);
    },
    onSettled: () => {
      void queryClient.invalidateQueries(recentSearchesQuery());
    },
  });

  return { deleteRecentSearch: mutate, ...rest };
};
